import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zan",
  "use": "icon-zan-usage",
  "viewBox": "0 0 15.87 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.87 15\" id=\"icon-zan\">\n  <path id=\"icon-zan_点赞\" class=\"cls-1\" d=\"M2119.06,1270.01a3.271,3.271,0,0,0-2.53-1.19h-3.67l0.59-1.92a2.21,2.21,0,0,0-.33-1.99,2.236,2.236,0,0,0-1.82-.91,2.212,2.212,0,0,0-2.13,1.55l-1.58,3.27h-2.14a1.507,1.507,0,0,0-1.51,1.5v7.18a1.507,1.507,0,0,0,1.51,1.5h11.85a1.426,1.426,0,0,0,1.4-1.14l1.04-5.15A3.254,3.254,0,0,0,2119.06,1270.01Zm-13.61,7.99a0.5,0.5,0,0,1-.5-0.5v-7.18a0.5,0.5,0,0,1,.5-0.5h1.95V1278h-1.95Zm13.3-5.48-1.04,5.14a0.41,0.41,0,0,1-.41.34h-8.89v-8.57l1.69-3.53a1.247,1.247,0,1,1,2.39.71l-0.99,3.21h5.03A2.253,2.253,0,0,1,2118.75,1272.52Z\" transform=\"translate(-2103.94 -1264)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/zan.svg
// module id = Tve9
// module chunks = 41